import React from 'react';
import { useTheme } from '../ThemeProvider';

interface MagicHeaderProps {
  children: React.ReactNode;
  onWindowDragMouseDown?: (e: React.MouseEvent) => void;
}

export const MagicHeader: React.FC<MagicHeaderProps> = ({
  children,
  onWindowDragMouseDown,
}: MagicHeaderProps) => {
  const { provideTailwind } = useTheme();

  return (
    <div className={`window-drag px-4 pb-1 sm:pb-0`}>
      <div
        className={`interactive window-drag flex items-center rounded-full p-3 shadow-lg relative`}
        style={{
          background:
            'linear-gradient(to right, #DB1667 0%, #DB1667 17%, rgba(9, 0, 255, 0.43) 100%)',
          padding: '2px',
        }}
        onMouseDown={(e) => {
          // Only trigger drag if the target is not an interactive element
          const target = e.target as HTMLElement;
          // Only prevent dragging on elements that explicitly have window-no-drag class
          const shouldPreventDrag =
            target.classList.contains('window-no-drag') ||
            target.closest('.window-no-drag');

          if (!shouldPreventDrag && onWindowDragMouseDown) {
            onWindowDragMouseDown(e);
          }
        }}
      >
        <div
          className={`flex items-center ${provideTailwind(
            'bg-primary',
          )} rounded-full w-full h-full relative p-3`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
